module.exports = __webpack_public_path__ + "static/img/emoj.74b71e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/emoj.png
// module id = 1222
// module chunks = 0